import Pipes from "./pipes";

import {timeSeriesDesktop, TimeSeriesDesktop, timeSeriesMobile, TimeSeriesMobile} from "./table/TimeSeriesComponent";
import {timeSeriesPeriodComponent, TimeSeriesPeriodComponent} from "./time-series-period/TimeSeriesPeriodComponent";
import {TimeSeriesService} from "./service/TimeSeriesService";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.time-series`;

    return angular.module(moduleName, [Pipes(moduleName)])
                  .component(TimeSeriesDesktop, timeSeriesDesktop())
                  .component(TimeSeriesMobile, timeSeriesMobile())
                  .component(TimeSeriesPeriodComponent, timeSeriesPeriodComponent())
                  .service(TimeSeriesService.id, TimeSeriesService)
                  .name;
}
